import MintStatus from "components/MintStatus";
import WienerBox from "components/WienerBox";
import WienerLoading from "components/WienerLoading";
import { PrimaryButton } from "Element/Button";
import Container from "Element/Container";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { mintSelector, setMintStatus } from "redux/mint/slice";
import { MintFooterWrapper, MintInfo, MintingWrapper } from "./styled";

const Minting = () => {
  const { loading, mintStatus } = useSelector(mintSelector);
  const dispatch = useDispatch();
  const handleClickHome = () => {
    dispatch(setMintStatus(undefined));
  };
  return (
    <Container>
      <MintingWrapper
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        as={motion.div}
        initial={{ x: "-100%" }}
        animate={{ x: 0 }}
      >
        {loading ? (
          <>
            <WienerLoading />
            <MintFooterWrapper
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <MintInfo>Minting Processed</MintInfo>
              {/* <SecondaryButton>Cancel</SecondaryButton> */}
            </MintFooterWrapper>
          </>
        ) : mintStatus !== undefined ? (
          <>
            <MintStatus isSuccess={mintStatus} />
            <MintFooterWrapper
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <MintInfo>
                {mintStatus
                  ? "Your Minting Successes, You’ve got n Sausage."
                  : "Your Minting Failed, Please Check Your Internet Connection."}
              </MintInfo>
              <PrimaryButton onClick={handleClickHome}>
                GO BACK TO HOME
              </PrimaryButton>
            </MintFooterWrapper>
          </>
        ) : (
          <>
            <WienerBox />
          </>
        )}
      </MintingWrapper>
    </Container>
  );
};

export default Minting;
